import { Accordion } from "../../../elements";
import { mountWithLkid } from "../../../support";
import { useFooter } from "../hooks";
import styles from "./footer-collapsable-mobile.module.css";

export function FooterCollapsableMobile() {
  const { links, handleFooterLinkClick, getLinkTarget } = useFooter();

  return (
    <div className={styles.Container}>
      <div className={styles.Banner}>
        <p>
          Nossos canais de atendimento são 100% digitais. Precisa de ajuda?{" "}
          <a
            href={mountWithLkid({
              ...links.HELP.YOU,
              lkid: "1439",
            })}
            {...getLinkTarget(
              mountWithLkid({
                ...links.HELP.YOU,
                lkid: "1439",
              })
            )}
            className={styles.BannerLink}
            aria-label="Acesse nossa Central de Ajuda"
          >
            <span style={{ display: "none" }}>
              Acesse nossa Central de Ajuda
            </span>{" "}
            CLIQUE AQUI.
          </a>
        </p>
      </div>
      <Accordion isSingle={true}>
        <Accordion.Item>
          <Accordion.Header color="#fff">
            <h2 className={styles.Title}>Comprar</h2>
          </Accordion.Header>
          <Accordion.Body>
            <ul className={styles.Links}>
              {Object.values(links?.BUY || {}).map((link) => {
                const href = mountWithLkid(link);
                return (
                  <li key={link.id}>
                    <a
                      id={link.id}
                      className={styles.Link}
                      href={href}
                      data-testid={link.testId}
                      {...getLinkTarget(href)}
                      data-qa={`${link.dataQA}-mobile`}
                    >
                      {link.text}
                    </a>
                  </li>
                );
              })}
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Header color="#fff">
            <h2 className={styles.Title}>Vender</h2>
          </Accordion.Header>
          <Accordion.Body>
            <ul className={styles.Links}>
              {Object.values(links?.SELL || {}).map((link) => {
                const href = mountWithLkid(link);
                return (
                  <li key={link.id}>
                    <a
                      id={link.id}
                      className={styles.Link}
                      href={href}
                      data-testid={link.testId}
                      {...getLinkTarget(href)}
                      data-qa={`${link.dataQA}-mobile`}
                    >
                      {link.text}
                    </a>
                  </li>
                );
              })}
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        {links.SUBSCRIPTION && (
          <Accordion.Item>
            <Accordion.Header color="#fff">
              <h2 className={styles.Title}>Assinar</h2>
            </Accordion.Header>
            <Accordion.Body>
              <ul className={styles.Links}>
                {Object.values(links?.SUBSCRIPTION || {}).map((link) => {
                  const href = mountWithLkid(link);
                  return (
                    <li key={link.id}>
                      <a
                        id={link.id}
                        className={styles.Link}
                        href={href}
                        data-testid={link.testId}
                        {...getLinkTarget(href)}
                        data-qa={`${link.dataQA}-mobile`}
                      >
                        {link.text}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        )}
        <Accordion.Item>
          <Accordion.Header color="#fff">
            <h2 className={styles.Title}>Serviços</h2>
          </Accordion.Header>
          <Accordion.Body>
            <ul className={styles.Links}>
              {Object.values(links?.SERVICES || {}).map((link) => {
                const href = mountWithLkid(link);
                return (
                  <li key={link.id}>
                    <a
                      id={link.id}
                      className={styles.Link}
                      href={href}
                      data-testid={link.testId}
                      {...getLinkTarget(href)}
                      data-qa={`${link.dataQA}-mobile`}
                    >
                      {link.text}
                    </a>
                  </li>
                );
              })}
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Header color="#fff">
            <h2 className={styles.Title}>Notícias WM1</h2>
          </Accordion.Header>
          <Accordion.Body>
            <ul className={styles.Links}>
              {Object.values(links?.NEWS || {}).map((link) => {
                const href = mountWithLkid(link);
                return (
                  <li key={link.id}>
                    <a
                      id={link.id}
                      className={styles.Link}
                      href={href}
                      data-testid={link.testId}
                      {...getLinkTarget(href)}
                      data-qa={`${link.dataQA}-mobile`}
                    >
                      {link.text}
                    </a>
                  </li>
                );
              })}
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Header color="#fff">
            <h2 className={styles.Title}>Ajuda</h2>
          </Accordion.Header>
          <Accordion.Body>
            <ul className={styles.Links}>
              {Object.values(links?.HELP || {}).map((link) => {
                const href = mountWithLkid(link);
                return (
                  <li key={link.id}>
                    <a
                      id={link.id}
                      className={styles.Link}
                      href={href}
                      data-testid={link.testId}
                      {...getLinkTarget(href)}
                      data-qa={`${link.dataQA}-mobile`}
                    >
                      {link.text}
                    </a>
                  </li>
                );
              })}
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Header color="#fff">
            <h2 className={styles.Title}>Institucional </h2>
          </Accordion.Header>
          <Accordion.Body>
            <ul className={styles.Links}>
              {Object.values(links?.INSTITUTIONAL || {}).map((link) => {
                const href = mountWithLkid(link);
                return (
                  <li key={link.id}>
                    <a
                      id={link.id}
                      className={styles.Link}
                      href={href}
                      data-testid={link.testId}
                      {...getLinkTarget(href)}
                      data-qa={`${link.dataQA}-mobile`}
                      onClick={(event) => {
                        handleFooterLinkClick(event, link.id);
                      }}
                    >
                      {link.text}
                    </a>
                  </li>
                );
              })}
            </ul>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}
